import React from 'react';
import { Globe } from 'lucide-react';
import { useTranslation } from '../../../contexts/TranslationContext';
import ThemeToggle from '../../../components/ThemeToggle';

const LanguageThemeToggle: React.FC = () => {
  const { locale, changeLocale, availableLocales } = useTranslation();
  const currentLocale = availableLocales.find(l => l.code === locale) || availableLocales[0];

  const handleLanguageChange = async () => {
    const newLocale = locale === 'en' ? 'sw' : 'en';
    await changeLocale(newLocale);
  };

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-end gap-3">
          {/* Language Toggle */}
          <button
            onClick={handleLanguageChange}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors focus:outline-none focus:ring-2 focus:ring-primary shadow-md"
            aria-label="Toggle language"
          >
            <Globe className="h-5 w-5" />
            <span className="text-sm font-medium">{currentLocale.nativeName}</span>
          </button>

          {/* Theme Toggle */}
          <div className="shadow-md">
            <ThemeToggle variant="icon-only" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageThemeToggle;